import React from 'react'

type SearchProps = {
  width?: number,
  height?: number,
  title?: string
  titleId?: string
}

const Search = ({ height = 24, width = 24, title = "", titleId = "" }: SearchProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--search"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <title id={titleId}>{title}</title>
      <path d="M23.608 23.707c-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.704-0.293l-7.653-7.682c-1.535 1.233-3.477 1.975-5.59 1.975-4.944 0-8.967-4.037-8.967-8.999 0-4.963 4.023-9.001 8.967-9.001s8.966 4.038 8.966 9.001c0 2.121-0.739 4.070-1.967 5.61l7.653 7.682c0.389 0.39 0.389 1.024 0 1.414zM8.956 2c-3.846 0-6.974 3.141-6.974 7.001s3.128 6.999 6.974 6.999c3.845 0 6.974-3.14 6.974-6.999s-3.129-7.001-6.974-7.001z" />
    </svg>
  )
}

export default Search
